import { render, staticRenderFns } from "./PortfolioProject.vue?vue&type=template&id=e5caac36&scoped=true&"
import script from "./PortfolioProject.vue?vue&type=script&lang=ts&"
export * from "./PortfolioProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5caac36",
  null
  
)

export default component.exports